import React from "react";
import PropTypes from "prop-types";

/**
 * 列表雙行儲存格(主文+灰色副文)。
 * WF_v3 的列表大量使用這個版式(IP 資訊/通知規則的觸發條件等);
 * 第二個頁面用到時依規則升級進共用層(figma-mcp.md:同一覆寫第二次必須升級)。
 */
export const TwoLineCell = ({ main, subs = [] }) => (
  <div>
    <div className="fw-medium">{main ?? "--"}</div>
    {subs.filter(Boolean).map((s, i) => (
      <div key={typeof s === "string" ? s : i} className="text-muted font-size-12">{s}</div>
    ))}
  </div>
);
TwoLineCell.propTypes = {
  main: PropTypes.node,
  subs: PropTypes.arrayOf(PropTypes.node),
};
